import { render, staticRenderFns } from "./globalAssetModal.vue?vue&type=template&id=c4ff33c4&scoped=true"
import script from "./globalAssetModal.vue?vue&type=script&lang=js"
export * from "./globalAssetModal.vue?vue&type=script&lang=js"
import style0 from "./globalAssetModal.vue?vue&type=style&index=0&id=c4ff33c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ff33c4",
  null
  
)

export default component.exports